import { Switch } from '@headlessui/react';
import clsx from 'clsx';

export default function BDSwitch({
  checked,
  onChange,
  disabled,
  className,
  ...rest
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={clsx(
        'data-[checked]:bg-bd-primary bg-bd-contrast group inline-flex h-7 w-12 cursor-pointer items-center rounded-full transition',
        className
      )}
      {...rest}
    >
      <span
        aria-hidden="true"
        className="size-5 translate-x-1 rounded-full bg-white transition group-data-[checked]:translate-x-6"
      />
    </Switch>
  );
}
